document.addEventListener("DOMContentLoaded", function () {
  const headerDefault = document.querySelector(".header-default");
  const headerScrolled = document.querySelector(".header-scrolled");
  const header = document.querySelector(".header2");

  function checkScroll() {
    const isMobile = window.innerWidth <= 749; // モバイル判定

    if (isMobile) {
      // モバイルでは常に header-default を表示、スクロールヘッダーは無効
      if (headerDefault) headerDefault.style.display = "block";
      if (headerScrolled) headerScrolled.classList.remove("is-visible");
      if (header) header.classList.remove("is-scrolled");
      return; // モバイルはここで終了
    }

    // PC用処理（スクロールで色切り替え）
    if (window.scrollY > 50) {
      if (headerDefault) headerDefault.classList.add("is-visible");
    } else {
      if (headerDefault) headerDefault.classList.remove("is-visible");
    }
  }

  checkScroll();
  window.addEventListener("scroll", checkScroll);
  window.addEventListener("resize", checkScroll); // 画面幅変更にも対応
});


